import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import audiencesTableState from '../modules/audiencesTableState/reducers';
import chatbotSidebarState from '../modules/chatbotSidebarState/reducers';
import connectionsTableState from '../modules/connectionsTableState/reducers';
import contactTableState from '../modules/contactTableState/reducers';
import mailchimpConnectionsTableState from '../modules/mailchimpConnectionsTableState/reducers';
import modalState from '../modules/modalsState/reducers';
import onboardingState from '../modules/onboardingState/reducers';
import recipientsTableState from '../modules/recipientsTableState/reducers';
import registerFlowState from '../modules/registerFlowState/reducers';
import rssFeedTableState from '../modules/rssFeedTableState/reducers';
import { StoreState } from '../store-interfaces';
import adAccounts from './adAccounts';
import adConfigs from './adConfigs';
import adEntities from './adEntities';
import affiliates from './affiliates';
import { ambassadorInfo } from './ambassadorInfo';
import analytics from './analytics';
import apiKeys from './apiKeys';
import attribute from './attribute';
import audiences from './audiences';
import { automation } from './automation';
import { botAnalytics } from './botAnalytics';
import campaignPurposes from './campaignPurposes';
import campaigns from './campaigns';
import { campaignsOverview } from './campaignsOverview';
import chatbot from './chatbot';
import { chatStarters } from './chatStarters';
import { chatWidgetTroubleshooting } from './chatWidgetTroubleshooting';
import company from './company';
import companyUsers from './companyUsers';
import connectedPage from './connectedPage';
import connections from './connections';
import contacts from './contacts';
import { contactsByAudienceId } from './contactsByAudienceId';
import ctmAds from './ctmAds';
import { ctmInsights } from './ctmInsights';
import domain from './domain';
import { emailAccounts } from './emailAccounts';
import env from './env';
import errors from './errors';
import facebook from './facebook';
import fbPost from './fbPost';
import { featureFlags } from './featureFlags';
import { followUps } from './followUps';
import { googleSheets } from './googleSheets';
import { guides } from './guides';
import { iceBreakers } from './iceBreakers';
import { instagram } from './instagram';
import invite from './invite';
import landingPages from './landingPages';
import leadAssignmentGroups from './leadAssignmentGroups';
import leadAssignments from './leadAssignments';
import leads from './leads';
import { mailchimp } from './mailchimp';
import mailchimpConnections from './mailchimpConnections';
import mainMenu from './mainMenu';
import mandatoryUpdateBanner from './mandatoryUpdateBanner';
import messengerAds from './messengerAds';
import network from './network';
import notes from './notes';
import notifications from './notifications';
import page from './page';
import pageGroup from './pageGroup';
import partners from './partners';
import { personas } from './personas';
import promoter from './promoter';
import promotions from './promotions';
import rssFeed from './rssFeed';
import sampleBots from './sampleBots';
import session from './session';
import { slack } from './slack';
import sponsoredMessages from './sponsoredMessage';
import subscription from './subscription';
import suggestion from './suggestion';
import tags from './tags';
import { templates } from './templates';
import trigger from './trigger';
import twilio from './twilio';
import variables from './variables';
import view from './view';
import { whatsNew } from './whatsNew';
import widget from './widget';

const rootReducer = combineReducers<StoreState>({
  adAccounts,
  adConfigs,
  adEntities,
  affiliates,
  ambassadorInfo,
  analytics,
  apiKeys,
  attribute,
  audiences,
  automation,
  audiencesTableState,
  botAnalytics,
  campaignPurposes,
  campaigns,
  campaignsOverview,
  chatbot,
  chatbotSidebarState,
  chatStarters,
  chatWidgetTroubleshooting,
  company,
  companyUsers,
  connectedPage,
  connections,
  contacts,
  connectionsTableState,
  mailchimpConnectionsTableState,
  contactsByAudienceId,
  contactTableState,
  ctmAds,
  ctmInsights,
  domain,
  emailAccounts,
  env,
  errors,
  facebook,
  fbPost,
  featureFlags,
  followUps,
  form: formReducer,
  googleSheets,
  guides,
  iceBreakers,
  instagram,
  invite,
  landingPages,
  leadAssignmentGroups,
  leadAssignments,
  leads,
  mainMenu,
  mandatoryUpdateBanner,
  messengerAds,
  modalState,
  network,
  notes,
  notifications,
  onboarding: onboardingState,
  page,
  pageGroup,
  partners,
  personas,
  promoter,
  promotions,
  recipientsTableState,
  registerFlowState,
  rssFeed,
  rssFeedTableState,
  sampleBots,
  session,
  sponsoredMessages,
  subscription,
  suggestion,
  tags,
  templates,
  trigger,
  twilio,
  variables,
  view,
  whatsNew,
  widget,
  mailchimp,
  mailchimpConnections,
  slack,
});

export default rootReducer;
